export const parseStringDateToISOString = (stringDate) => {
  const date = new Date(stringDate)
  return date.toISOString()
}

export const FORMAT_DATE_OPTIONS = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}

export const FORMAT_DATE_OPTIONS_WITH_HOUR = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}
